import type { DSThemeDefinition } from '@design-system/styles/themes/types'
import { variablesLight } from '@tenable/paladin-style-dictionary'
import { paladinThemeTokens } from '../paladin'

const tokens: Partial<DSThemeDefinition['tokens']> = {
  /**
   * Blade
   */

  'blade/backgroundColor/default': variablesLight.color.colorBackgroundPrimary,

  /**
   * HeadBar
   */

  'headBar/color/bodyBackgroundN': variablesLight.color.colorBackgroundPrimary
}

export const paladinWhiteThemeTokens: DSThemeDefinition = {
  ...paladinThemeTokens,
  tokens: { ...paladinThemeTokens.tokens, ...tokens }
}
